var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.1854 1.9155C15.9016 0.370117 18.0984 0.370121 18.8146 1.91551L22.1981 9.21628C22.4892 9.84437 23.0843 10.2773 23.7716 10.3607L31.7532 11.3301C33.4413 11.5351 34.1196 13.6198 32.8753 14.7789L26.981 20.2696C26.4755 20.7405 26.2488 21.439 26.3814 22.117L27.9285 30.0265C28.2552 31.6971 26.4786 32.9862 24.9918 32.1573L17.9739 28.2447C17.3685 27.9072 16.6315 27.9072 16.0261 28.2447L9.00822 32.1573C7.52142 32.9862 5.74475 31.6971 6.07151 30.0265L7.61858 22.117C7.7512 21.439 7.52451 20.7405 7.019 20.2696L1.12475 14.7789C-0.119589 13.6198 0.558671 11.5351 2.24684 11.3301L10.2284 10.3607C10.9157 10.2773 11.5108 9.84437 11.8019 9.21628L15.1854 1.9155Z",
    fill: "#F6CA56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.59b2d1070040ee764df197c26ce61926.svg";
export { ForwardRef as ReactComponent };